import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const aboutTitles: Record<CreditCardProductCategory, string> = {
    [CreditCardProductCategory.BalanceTransfer]:
        'About balance transfer credit cards',
    [CreditCardProductCategory.BestCards]: 'About credit cards',
    [CreditCardProductCategory.Cashback]: 'About cashback credit cards',
    [CreditCardProductCategory.Combined]:
        'About balance transfer and purchase credit cards',
    [CreditCardProductCategory.PoorCredit]: 'About credit cards for bad credit',
    [CreditCardProductCategory.Purchase]: 'About 0% purchase credit cards',
    [CreditCardProductCategory.Rewards]: 'About rewards credit cards',
    [CreditCardProductCategory.Travel]: 'About travel credit cards',
}

export default aboutTitles
